import styled from '@emotion/styled';
import { Row } from '../../../components/Grid';

export const ButtonWrapper = styled(Row)`
  flex: 1;
  align-items: flex-end;
`;
